import React, { useEffect, useRef, useState, useContext } from "react";
import { Transition } from "@tailwindui/react";
import { AiOutlineLeft } from "react-icons/ai";
import imgBanner from "../assets/image/index_banner.png";
import Book from "../components/Books/Book";
import Title from "../components/Title";
import { useQuery } from "react-query";
import { API } from "../config/api";
import { BookContext } from "../context/bookContext";
import ScreenLoader from "../components/Skeleton/ScreenLoader";
import NoData from "../components/Skeleton/NoData";
import Pagination from "../components/Pagination/Pagination";
function Index(props) {
  const [page, setpage] = useState(1);
  // eslint-disable-next-line
  const { isLoading, error, data: bookData, refetch } = useQuery(
    "getBooks",
    () =>
      API.get(
        `/books?categoryId=${category}&status=Approved&page=${page}&limit=8`
      )
  );
  const [category, setcategory] = useState("");
  // eslint-disable-next-line
  const [state, dispatch] = useContext(BookContext);
  // HandlePageClick
  const handlePageClick = (e) => {
    const selectedPage = e.selected;
    setpage(selectedPage + 1);
  };

  useEffect(() => {
    setpage(page);
    refetch();
  }, [page]);
  // Get Categories
  useEffect(() => {
    // eslint-disable-next-line
    const getCategory = async () => {
      try {
        const res = await API.get("/categories");
        // eslint-disable-next-line
        dispatch({
          type: "GET_CATEGORIES",
          payload: res.data.data,
        });
      } catch (error) {
        dispatch({
          type: "ERROR",
        });
      }
    };
    // eslint-disable-next-line
    if (!state.bookCategories) {
      getCategory();
    }
  }, []);

  const [show, setShow] = useState(false);
  const container = useRef(null);
  // Handle Click Outside of Dropdown
  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (!container.current.contains(event.target)) {
        if (!show) return;
        setShow(false);
      }
    };
    window.addEventListener("click", handleOutsideClick);
    return () => window.removeEventListener("click", handleOutsideClick);
  }, [show, container]);
  // Change Category
  const changeCategory = (id) => {
    setcategory(id);
    setShow(false);
  };

  useEffect(() => {
    refetch();
  }, [category, show]);

  return (
    <div>
      {/* container header */}
      <div
        className="w-full rounded-md mb-12"
        style={{ backgroundColor: "#E6F2FD" }}
      >
        <div className="grid grid-cols-12 lg:text-left text-center lg:px-16">
          {/* left col */}
          <div className="col-span-12 lg:col-span-8 py-20">
            <p
              className="text-6xl font-bold font-sans text-title"
              style={{
                lineHeight: "97.44px",
                fontSize: "96px",
              }}
            >
              Share, read and <span className="italic"> love</span>
            </p>
            <p className="mt-4 text-2xl">Reading is fascinating</p>
          </div>
          {/* right col */}
          <div className="hidden lg:block col-span-4 py-8">
            <img className="w-4/5 mx-auto" src={imgBanner} alt="" />
          </div>
        </div>
      </div>
      {/* List book */}
      <div>
        <div className="flex flex-wrap place-content-between">
          <div className="w-1/2">
            <Title name="List Book" />
          </div>

          {/* Category button */}
          <div ref={container} className="flex justify-end text-left w-1/2">
            <Transition
              show={show}
              enter="transition duration-100"
              enterFrom="opacity-0 scale-95"
              enterTo="opacity-100 scale-100"
              leave="transition ease-in duration-75"
              leaveFrom="opacity-100 scale-100"
              leaveTo="opacity-0 scale-95"
            >
              <div
                className="inline-block absolute shadow-lg right-0  rounded-lg origin-top-right "
                style={{ marginRight: "10rem", minWidth: "150px" }}
              >
                <div className="rounded-md bg-white shadow-xs">
                  <div
                    className="py-1"
                    role="menu"
                    aria-orientation="vertical"
                    aria-labelledby="options-menu"
                    onClick={() => changeCategory("")}
                  >
                    <div
                      className="cursor-pointer text-lg block px-4 py-2 text-sm leading-5 text-gray-700 hover:bg-gray-100 hover:text-gray-900 focus:outline-none focus:bg-gray-100 focus:text-gray-900"
                      role="menuitem"
                    >
                      All
                    </div>
                  </div>
                  {state.loading || !state.bookCategories ? (
                    <p>Loading..</p>
                  ) : state.error ? (
                    <p>Error Happend</p>
                  ) : (
                    state.bookCategories.map((item, index) => {
                      return (
                        <div
                          key={index}
                          className="py-1"
                          role="menu"
                          aria-orientation="vertical"
                          aria-labelledby="options-menu"
                          onClick={() => changeCategory(item.id)}
                        >
                          <div
                            className="cursor-pointer text-lg block px-4 py-2 text-sm leading-5 text-gray-700 hover:bg-gray-100 hover:text-gray-900 focus:outline-none focus:bg-gray-100 focus:text-gray-900"
                            role="menuitem"
                          >
                            {item.name}
                          </div>
                        </div>
                      );
                    })
                  )}
                </div>
              </div>
            </Transition>
            <div className="inline-block">
              <button
                className="flex focus:outline-none bg-gray-200 px-6 py-3 hover:bg-orange-custom hover:text-white rounded-md text-lg"
                id="options-menu"
                onClick={(e) => setShow(!show)}
              >
                <AiOutlineLeft className="mr-3 self-center" />
                Category
              </button>
            </div>
          </div>
        </div>
        {/* card */}
        <div>
          {isLoading || !bookData ? (
            <ScreenLoader />
          ) : error ? (
            <h1>{error.message}</h1>
          ) : bookData.data.data.length === 0 ? (
            <NoData />
          ) : (
            <>
              <div className="grid lg:grid-cols-4 md:grid-cols-3 sm:grid-cols-2 grid-cols-1 gap-4 md:gap-10">
                {bookData.data.data.map((book, index) => (
                  <Book key={index} data={book}></Book>
                ))}
              </div>
              <div className="flex w-full justify-center mt-6">
                <Pagination
                  handleChangePage={handlePageClick}
                  pageCount={bookData.data.totalPages}
                />
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
}

export default Index;
